// extracted by mini-css-extract-plugin
export default {"boxContainer":"InfoBox_boxContainer__FX8ew","boxHead":"InfoBox_boxHead__rhjoz","boxData":"InfoBox_boxData__X7M2l"};